// extracted by mini-css-extract-plugin
export default {"BannerStrip":"BannerStrip-styles__BannerStrip__OIuhp"};